/* unplugin-vue-components disabled */import { render } from "./persona-info.vue?vue&type=template&id=ce78e0ca&scoped=true"
import script from "./persona-info.vue?vue&type=script&lang=js"
export * from "./persona-info.vue?vue&type=script&lang=js"

import "./persona-info.vue?vue&type=style&index=0&id=ce78e0ca&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce78e0ca"],['__file',"src/components/cards-v2/persona/persona-info.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ce78e0ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ce78e0ca', __exports__)) {
    api.reload('ce78e0ca', __exports__)
  }
  
  module.hot.accept("./persona-info.vue?vue&type=template&id=ce78e0ca&scoped=true", () => {
    api.rerender('ce78e0ca', render)
  })

}


export default __exports__